import { render } from "./tokyo.vue?vue&type=template&id=7a346506&scoped=true"
import script from "./tokyo.vue?vue&type=script&lang=js"
export * from "./tokyo.vue?vue&type=script&lang=js"

import "./tokyo.vue?vue&type=style&index=0&id=7a346506&lang=scss&scoped=true"
import "./tokyo.vue?vue&type=style&index=1&id=7a346506&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7a346506"

export default script